import { useState } from 'react'

import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import CancelConfirmButtons from 'Components/UI/Molecules/CancelConfirmButtons'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import { interfaces } from 'service/interfaces'

const ExportCompaction = (props) => {
  const { handleClose, open } = props

  const createDismissableSnackbar = useCustomSnackbar()

  const [isLoading, setIsLoading] = useState(false)

  const onSubmit = async () => {
    setIsLoading(true)
    await interfaces.compactionInterface.exportCompaction().then((res) => {
      window.location.assign(res.data)
      createDismissableSnackbar('Tabla de actas compactación descargada!', {
        variant: 'success',
      })
      handleClose(true)
    })
    setIsLoading(false)
  }

  return (
    <div>
      <DialogComponent
        tipo="center"
        open={open}
        handleclose={handleClose}
        handleclosedisabled={isLoading}
        title="¿Desea exportar la tabla de actas compactación?"
        widthLarge="550px"
        disableBackdropClick={isLoading}
        disableEscapeKeyDown={isLoading}
        disableChildHeight
        actions={
          <CancelConfirmButtons
            onClickCancel={handleClose}
            onClickSubmit={onSubmit}
            isLoading={isLoading}
            disabledCancel={isLoading}
            disabledSubmit={isLoading}
          />
        }
      />
    </div>
  )
}

export default ExportCompaction
